'use strict';

(function () {
	const checkGroupPermission = function (user, siteName, requiredPermission) {
		const parts = requiredPermission.split('/');
		const type_ = parts[1],
			value = parts[2],
			subType_ = parts[3];
		const matchGroup = function (x) {
			return (
				(type_ === 'smart' && type_ === x.type && value === x.smartType) ||
				(type_ === 'custom' && type_ === x.type && value === x.name)
			);
		};

		if (subType_ == null) {
			return user.localAccess.groups.some(matchGroup);
		} else if (subType_ === 'role') {
			const role = parts[4];
			return user.localAccess.groups.some(function (x) {
				return (
					matchGroup(x) &&
					x.roles.some(function (y) {
						return y === role;
					})
				);
			});
		} else if (subType_ === 'permission') {
			const permission = parts[4];
			return user.localAccess.groups.some(function (x) {
				return (
					matchGroup(x) &&
					x.permissions.some(function (y) {
						return y === permission;
					})
				);
			});
		}
		return false;
	};

	const checkRolePermission = function (user, siteName, requiredPermission) {
		const parts = requiredPermission.split('/');
		const role = parts[1];
		const type_ = parts[2];

		if (type_ == null) {
			return user.localAccess.roles.has(role);
		} else if (type_ === 'location') {
			const locationId = parts[3];
			const access = user.localAccess.locations.get(locationId) || { roles: [] };
			return access.roles.some(function (x) {
				return x === role;
			});
		}
		return false;
	};

	const checkPermissionPermission = function (user, siteName, requiredPermission) {
		const parts = requiredPermission.split('/');
		const permission = parts[1],
			type_ = parts[2];

		if (type_ == null) {
			return user.localAccess.permissions.has(permission);
		} else if (type_ === 'location') {
			const locationId = parts[3];
			const access = user.localAccess.locations.get(locationId) || { permissions: [] };
			return access.permissions.some(function (x) {
				return x === permission;
			});
		}
		return false;
	};

	const permissionCheckers = {
		permission: checkPermissionPermission,
		group: checkGroupPermission,
		role: checkRolePermission
	};

	const hasPermission = function (user, siteName, requiredPermission) {
		const parts = requiredPermission.split('/');
		const accessType = parts[0];
		const permissionChecker =
			permissionCheckers[accessType] ||
			function () {
				return false;
			};

		try {
			return permissionChecker(user, siteName, requiredPermission);
		} catch {
			return false;
		}
	};

	const checkPermission = function (siteName, user, requiredPermission) {
		return new Promise(function (resolve, reject) {
			if (requiredPermission.includes('|')) {
				const permissions = requiredPermission.split('|');
				if (permissions.some(p => hasPermission(user, siteName, p))) {
					resolve(true);
				} else {
					reject(false);
				}
			} else {
				if (hasPermission(user, siteName, requiredPermission)) {
					resolve(true);
				} else {
					reject(false);
				}
			}
		});
	};

	module.exports = { checkPermission, hasPermission };
})(typeof module !== 'undefined' && module.exports);
